// lib/filters/parseOrderLink
var name = 'auto-export-poezd'
var link = 'auto-export-poezd'

function parseLink(name = null, parseLink = null) {
    return function (number, transport, ready, status, sklad) {
        if (number) number = number.trim()
        var link = parseLink + '/' + number
        var data = {}
        let txt = ["Оформление заявки <br /> недоступно", "Заявка <br /> оформлена", 'Заявка','Заявка отменена'];
        data.name = name
        if (number) data.number = number
        if (sklad) data.sklad = sklad

        data = JSON.stringify(data)
        if (ready && status !== 0 ) {
            return `<a data-data='${data}' href="${link}">${txt[status]}</a>`
        } else return `${txt[0]}`;

    }
}


export default {
    filters: {parseOrderLink: parseLink(name, link)}
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseOrderLink.js
 **/